import { render } from "./Home.vue?vue&type=template&id=38e6e9d6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=38e6e9d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-38e6e9d6"

export default script